export const isActivityClaimPath = (path: string) =>
  /^\/activities\/claim\/[a-zA-Z0-9_-]{1,36}\/?$/.test(path)
